import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_arrow-pointer-right",
  "use": "svg_arrow-pointer-right-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"svg_arrow-pointer-right\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m12.17 7-3.59 3.59L10 12l6-6-6-6-1.41 1.41L12.17 5H0v2h12.17z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol